import { render, staticRenderFns } from "./tech.vue?vue&type=template&id=067e1b43&scoped=true&"
import script from "./tech.vue?vue&type=script&lang=js&"
export * from "./tech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e1b43",
  null
  
)

export default component.exports